import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ContactInfo } from "../models/ContactInfo";


@Injectable({
    providedIn: 'root'
})
export class AdminDataService {

    constructor(private http: HttpClient) {

    }

    saveContactInfo(contactInfo: ContactInfo): Observable<boolean> {
        return this.http.post<boolean>('api/admin/savecontactinfo', contactInfo);
    }
}